export const NAV_ITEMS = [
  { key: "account", label: "My Account", icon: "👤" },
  { key: "orders", label: "Orders", icon: "📦" },
  { key: "prescriptions", label: "Prescriptions", icon: "📋" },
  // { key: "wishlist", label: "Wishlist", icon: "❤️" },
  { key: "addresses", label: "Address Book", icon: "📍" },
  { key: "management", label: "Account Management", icon: "⚙️" },
];
